import myInfoRoutes from './myInfo';

// routers 내보낼 때 사용
const myInfoRouters = [...myInfoRoutes];

export default myInfoRouters;
